import React from 'react';

export default function useStyle({ id, style }: { id: string; style: string; }) {
    React.useEffect(() => {
        if (!style) {
            return;
        }

        const styleId = `style-${id}`;
        let styleEl = document.getElementById(styleId);
        if (styleEl) {
            styleEl.remove();
        }
        styleEl = document.createElement('style');
        styleEl.id = styleId;
        styleEl.innerHTML = style;
        document.head.appendChild(styleEl);

        return () => {
            const styleEl = document.getElementById(styleId);
            if (styleEl) {
                styleEl.remove();
            }
        };
    }, [id, style]);
}
